/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { CountAdjReasonProcessTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const countAdjReasonProcessFetchCountAdjReasonProcessLoading = (state, { boolean }) => ({
  ...state,
  processIsLoading: boolean
});

export const countAdjReasonProcessFetchCountAdjReasonProcessSuccess = (state, { process }) => ({
  ...state,
  process
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [CountAdjReasonProcessTypes.COUNT_ADJ_REASON_PROCESS_FETCH_COUNT_ADJ_REASON_PROCESS_LOADING]: countAdjReasonProcessFetchCountAdjReasonProcessLoading,
  [CountAdjReasonProcessTypes.COUNT_ADJ_REASON_PROCESS_FETCH_COUNT_ADJ_REASON_PROCESS_SUCCESS]: countAdjReasonProcessFetchCountAdjReasonProcessSuccess
});
